import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsOverview = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Total Consultations',
      value: metrics?.total,
      icon: 'Calendar',
      bgColor: 'bg-[#E6F0F5]',
      iconColor: 'text-[#002B45]',
      trend: null
    },
    {
      label: 'Pending Review',
      value: metrics?.pending,
      icon: 'Clock',
      bgColor: 'bg-yellow-50',
      iconColor: 'text-yellow-600',
      trend: null
    },
    {
      label: 'Confirmed',
      value: metrics?.confirmed,
      icon: 'CheckCircle',
      bgColor: 'bg-[#D1F5F0]',
      iconColor: 'text-[#1FB5A5]',
      trend: null
    },
    {
      label: 'Completed',
      value: metrics?.completed,
      icon: 'CheckCheck',
      bgColor: 'bg-green-50',
      iconColor: 'text-green-600',
      trend: null
    },
    {
      label: 'Cancelled',
      value: metrics?.cancelled,
      icon: 'XCircle',
      bgColor: 'bg-red-50',
      iconColor: 'text-red-600',
      trend: null
    },
    {
      label: 'Conversion Rate',
      value: `${metrics?.conversionRate}%`,
      icon: 'TrendingUp',
      bgColor: 'bg-purple-50',
      iconColor: 'text-purple-600',
      trend: null
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
      {metricCards?.map((metric, index) => (
        <div 
          key={index}
          className="bg-white rounded-xl shadow-elevation-1 p-6 hover:shadow-elevation-2 transition-shadow duration-300"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 ${metric?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} className={metric?.iconColor} />
            </div>
            {metric?.trend && (
              <span className="text-xs font-medium text-green-600 flex items-center gap-1">
                <Icon name="ArrowUp" size={12} />
                {metric?.trend}
              </span>
            )}
          </div>
          <div>
            <p className="text-2xl font-bold text-foreground mb-1">{metric?.value}</p>
            <p className="text-sm text-muted-foreground">{metric?.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsOverview;